import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  &&&& {\n    ', '\n  }\n'], ['\n  &&&& {\n    ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        display: none;\n      '], ['\n        display: none;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-right: ', ';\n  display: inline-block;\n  vertical-align: middle;\n'], ['\n  margin-right: ', ';\n  display: inline-block;\n  vertical-align: middle;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  opacity: ', ';\n  height: ', ';\n  transition: height 0.3s linear, opacity 0.3s linear;\n'], ['\n  opacity: ', ';\n  height: ', ';\n  transition: height 0.3s linear, opacity 0.3s linear;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  padding: 10px;\n'], ['\n  padding: 10px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  padding: 10px;\n  color: ', ';\n'], ['\n  padding: 10px;\n  color: ', ';\n']);

import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import find from 'lodash/find';
import moment from 'moment';
import styled, { css } from 'styled-components';
import { task as taskApi } from 'gipsy-api';

import { utils, translations, models, styles } from 'gipsy-misc';

import { ContextMenuContainer, ContextMenu, ContextMenuItem } from '../../..';
import { Icon, DraftEditor, UserPicture, LargeButton } from '../../..';
import injected from '../../../injected';
import Field from '../../components/Field';

var Comments = styled(Field)(_templateObject, function (_ref) {
  var hidden = _ref.hidden;
  return hidden && css(_templateObject2);
});

/* ******************* Single comment posted by user ******************* */

var SingleComment = function (_PureComponent) {
  _inherits(SingleComment, _PureComponent);

  function SingleComment() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, SingleComment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SingleComment.__proto__ || Object.getPrototypeOf(SingleComment)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      readOnly: true,
      value: ''
    }, _this.onChange = function (_ref3) {
      var paramName = _ref3.paramName,
          value = _ref3.value;

      _this.setState({
        value: value
      });
    }, _this.onEditMode = function (closeMenu) {
      _this.setState({
        readOnly: false
      });
      _this.toolbarEditor.focus();
      if (closeMenu) {
        closeMenu();
      }
      utils.DOM.scrollWhenExistsToElementWithId(_this.props.comment.id, 'panel-scrollable');
    }, _this.onDelete = function (comment, closeMenu) {
      if (_this.props.remove) {
        _this.props.remove(comment);
      }
      if (closeMenu) {
        closeMenu();
      }
    }, _this.onKeyPress = function (e) {
      /* edit comment on enter press */
      if (e.keyCode === 13 && !e.nativeEvent.shiftKey) {
        e.stopPropagation();
        _this.edit();
        return 'handled';
      }
    }, _this.edit = function () {
      if (_this.props.edit && _this.props.comment) {
        var newComment = _extends({}, _this.props.comment, {
          richText: _this.state.value
        });
        _this.props.edit(newComment);
      }
      _this.setState({ readOnly: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SingleComment, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          comment = _props.comment,
          isAuthor = _props.isAuthor,
          isNew = _props.isNew;
      var readOnly = this.state.readOnly;


      var dateLabel = comment.edited ? moment(comment.creationTime).fromNow() + translations.taskPanel.comment.editedLabel : moment(comment.creationTime).fromNow();

      return React.createElement(
        'div',
        { id: comment.id, className: 'comment' + (comment.pending ? ' pending' : '') + (isNew ? ' new' : '') },
        React.createElement(
          'div',
          { className: 'comment-header' },
          React.createElement(
            'div',
            { className: 'author' },
            React.createElement(StyledUserPicture, { src: get(comment, 'from.picture'), size: 26 }),
            React.createElement(
              'span',
              null,
              comment.from.displayName
            )
          ),
          React.createElement(
            'div',
            { className: 'date' },
            dateLabel
          ),
          comment.id && isAuthor && React.createElement(
            'div',
            { className: 'more' },
            React.createElement(
              ContextMenuContainer,
              null,
              function (ref, onContextMenu, closeMenu, isActive) {
                return React.createElement(
                  Fragment,
                  null,
                  React.createElement(Icon, { icon: 'More', onClick: onContextMenu }),
                  React.createElement(
                    ContextMenu,
                    { isActive: isActive, setRef: ref, clientX: -200 },
                    React.createElement(
                      ContextMenuItem,
                      { height: 20, onClick: function onClick() {
                          return _this2.onEditMode(closeMenu);
                        } },
                      React.createElement(
                        EditLabel,
                        null,
                        translations.taskPanel.comment.edit
                      )
                    ),
                    React.createElement(
                      ContextMenuItem,
                      { height: 20, onClick: function onClick() {
                          return _this2.onDelete(comment, closeMenu);
                        } },
                      React.createElement(
                        DeleteLabel,
                        null,
                        translations.general.delete
                      )
                    )
                  )
                );
              }
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'comment-content' },
          React.createElement(DraftEditor, {
            readOnly: readOnly,
            isNew: isNew,
            paramName: comment.id,
            compact: readOnly,
            padding: !readOnly,
            defaultValue: comment.richText,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            uploads: this.props.uploads,
            ref: function ref(_ref4) {
              return _this2.toolbarEditor = _ref4;
            },
            onImageUpload: this.props.onImageUpload,
            getUploadUrls: taskApi.uploads.images.request
          })
        ),
        !readOnly && React.createElement(
          StyledButton,
          { show: !readOnly, rightIconName: 'Send', onClick: this.edit, style: { marginTop: '10px' } },
          translations.taskPanel.comment.editButton
        )
      );
    }
  }]);

  return SingleComment;
}(PureComponent);

var StyledUserPicture = styled(UserPicture)(_templateObject3, styles.spacings.small);

/* ******************* Comment field ******************* */

var Comment = function (_PureComponent2) {
  _inherits(Comment, _PureComponent2);

  function Comment() {
    var _ref5,
        _this4 = this;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, Comment);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref5 = Comment.__proto__ || Object.getPrototypeOf(Comment)).call.apply(_ref5, [this].concat(args))), _this3), _this3.state = {
      value: '',
      disabled: false
    }, _this3.onChange = function (_ref6) {
      var paramName = _ref6.paramName,
          value = _ref6.value;

      _this3.setState({
        value: value
      });
    }, _this3.onFocus = function (e) {
      _this3.props.openField(e, _this3.props.id);
    }, _this3.onKeyPress = function (e) {
      /* add comment on enter press */
      if (e.keyCode === 13 && !e.nativeEvent.shiftKey) {
        e.stopPropagation();
        _this3.add();
        return 'handled';
      }
    }, _this3.add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var oldValue;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              oldValue = _this3.state.value;

              if (oldValue) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:

              _this3.setState({
                disabled: true,
                value: ''
              });

              if (_this3.toolbarEditor && _this3.toolbarEditor.clear) {
                /* necessary to clear content on return press */
                _this3.timeout = setTimeout(function () {
                  _this3.toolbarEditor.clear();
                }, 0);
              }

              _context.prev = 5;
              _context.next = 8;
              return _this3.props.onChange({
                paramName: _this3.props.id,
                value: models.comment(oldValue),
                method: 'add'
              });

            case 8:
              if (_this3._isMounted) {
                _this3.setState({
                  disabled: false,
                  value: ''
                });
              }
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](5);

              console.error(_context.t0);
              if (_this3._isMounted) {
                _this3.setState({
                  disabled: false,
                  value: oldValue
                });
              }

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[5, 11]]);
    })), _this3.remove = function (comment) {
      if (!_this3.isAuthor(comment)) {
        return;
      }
      _this3.props.onChange({
        paramName: _this3.props.id,
        value: comment,
        method: 'remove'
      });
    }, _this3.edit = function (comment) {
      if (!_this3.isAuthor(comment)) {
        return;
      }
      _this3.props.onChange({
        paramName: _this3.props.id,
        value: comment,
        method: 'edit'
      });
    }, _this3.isAuthor = function (comment) {
      return get(comment, 'from.userId') === injected.user.id;
    }, _this3.isNew = function (comment) {
      return !!find(_this3.props.notifications, function (n) {
        return n.commentId === comment.id && n.type === 'newComment' && !n.read;
      });
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(Comment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          id = _props2.id,
          isOpen = _props2.isOpen,
          mode = _props2.mode,
          comments = _props2.comments,
          editMode = _props2.editMode;
      var _state = this.state,
          value = _state.value,
          disabled = _state.disabled;


      if (mode === 'create') {
        return null;
      }

      return React.createElement(
        Comments,
        {
          hidden: editMode === 'recurring',
          className: 'comment-field active' + (isOpen ? ' open' : ''),
          onClick: utils.DOM.stopPropagation,
          onFocus: utils.DOM.stopPropagation },
        React.createElement(
          'div',
          { className: 'gp-layout gp-row' + (mode === 'edit' ? ' row' : ' semi-row') },
          React.createElement(DraftEditor, {
            ref: function ref(_ref8) {
              return _this5.toolbarEditor = _ref8;
            },
            placeholder: translations.taskPanel.comment.placeholder,
            paramName: id,
            onKeyPress: this.onKeyPress,
            onChange: this.onChange,
            onFocus: this.onFocus,
            padding: true,
            compact: !isOpen,
            onImageUpload: this.props.onImageUpload,
            uploads: this.props.uploads,
            getUploadUrls: taskApi.uploads.images.request,
            style: { marginBottom: 20 }
          }),
          React.createElement(
            StyledButton,
            { show: isOpen, rightIconName: 'Send', disabled: disabled, onClick: this.add },
            translations.taskPanel.comment.button
          ),
          React.createElement(
            'div',
            { className: 'comments' },
            comments && comments.map(function (comment) {
              return React.createElement(SingleComment, {
                key: 'comment-' + comment.id,
                comment: comment,
                isAuthor: _this5.isAuthor(comment),
                isNew: _this5.isNew(comment),
                remove: _this5.remove,
                edit: _this5.edit,
                uploads: _this5.props.uploads,
                onImageUpload: _this5.props.onImageUpload
              });
            })
          )
        )
      );
    }
  }]);

  return Comment;
}(PureComponent);

Comment.propTypes = {
  mode: PropTypes.string.isRequired,
  id: PropTypes.string,
  taskId: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  openField: PropTypes.func.isRequired,
  comments: PropTypes.array,
  notifications: PropTypes.array
};


var StyledButton = styled(LargeButton)(_templateObject4, function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return !props.show && '0px';
});

var EditLabel = styled.div(_templateObject5);

var DeleteLabel = styled.div(_templateObject6, styles.colors.pinkColor);

export default Comment;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Comment/index.js
// module id = 1131
// module chunks = 0